<template>
    <div class="sticky top-0 left-0 mr-4">
        <Link :class="[headerLink,]" href="/birds">{{ latestBirds?.length }} Detections</Link>
         <p>{{ latestBirdsUpdate }}</p>
        <div class="box bg-slate-800/10 p-2">

                <ul class="w-full flex flex-wrap">
                    <li v-for="b in latestBirds" :key="b.scientific_name + b.datetime" class="bird-id text-white overflow-hidden mb-6 w-full">
                    <ul class="w-full flex flex-wrap ">
                        <li class="w-1/3 overflow-hidden rounded flex-shrink-0">
                            <a :href="`https://en.wikipedia.org/wiki/${b.common_name}`" target="_blank">
                                <img class="w-full aspect-square object-cover border border-slate-600/40" :src="`/storage/birds/${b.common_name}.jpg`" :title="b.common_name">
                            </a>
                        </li>
                        <li class="w-2/3 flex flex-col justify-between min-w-0 pl-2">
                            <h2 class="text-lg font-semibold leading-tight truncate">
                                <a :href="`https://allaboutbirds.org/guide/${fixName(b.common_name)}`" target="_blank">{{ b.common_name }}</a>
                            </h2>
                            <div class="mt-1 mb-1">
                                <div class="h-1 w-full bg-amber-900 rounded-full overflow-hidden">
                                    <div class="h-full rounded-full bg-amber-500/50" :style="{ width: `${(b.confidence * 100).toFixed(0)}%` }"></div>
                                </div>
                                <p class="text-sm text-slate-400 mt-0.5">{{ (b.confidence * 100).toFixed(1) }}% confidence</p>
                            </div>
                            <p class="text-base text-amber-500">{{ formatDate(b.datetime, 'MMM D h:mma') }}</p>
                            <p class="text-sm text-amber-700">{{ b.detections }} detection<span v-if="b.detections > 1">s</span> this hour</p>
                        </li>
                    </ul>
                </li>
                </ul>
        </div>
    </div>
</template>
<script>
import { Link } from '@inertiajs/vue3'
import * as DataService from '../DataService.js'
import { mapState, mapWritableState } from 'pinia'
import { useGeneralStore } from '@/utils/useGeneralStore.js'
import dayjs from 'dayjs'
import gsap from 'gsap/all'

export default {
    name: 'BirdsLatest',
    props: ['trigger', 'birds'],
    components: { Link },
    watch: {
        trigger: {
            handler(n) {
                if(n) {
                    gsap.fromTo('.bird',
                        { scale: .8, y: 20, opacity: 0 },
                        { scale: 1, y: 0, opacity: 1, stagger: .05, duration: .3},
                    )
                }
            },
            deep: true,
            immediate: true
        },
        latestBirds: {
            handler(n) {
                // console.log(n);
            },
            deep: true,
            immediate: true

        }
    },
    computed: {
        ...mapState(useGeneralStore, ['headerLink']),
        ...mapWritableState(useGeneralStore, ['latestBirds', 'latestBirdsUpdate']),
        latestBirdsShortlist() {
            return this.latestBirds.slice(0,4);
        }
    },
    mounted() {
        this.latestBirds=this.birds ? this.birds : [];
        gsap.fromTo('.bird-id',
            { scale: .8, y: 20, opacity: 0 },
            { scale: 1, y: 0, opacity: 1, stagger: .05, duration: .2},
        )


    },
    methods: {
        formatDate(d, format) {
            return dayjs(d).format(format);
        },
        fixName(n) {
            n=n.replace(/ /g, '_');
            return n;
        },
        initSocket() {

        }
    }
}
</script>
<style lang="css">
.bird-id {
    opacity: 1;
}
</style>>
